export default __webpack_public_path__ + "static/media/aura.d5a02f7c.webp";